<div #checkbox class="avatar-checkbox" [ngClass]="{'disabled':disabled}">
    <wdpr-checkbox #checkbox
        class="checkbox"
        [checked]="checked"
        [attr.disabled]="disabled ? '' : null"
        (checked-changed)="sendEvent($event)">
    </wdpr-checkbox>
    <finder-avatar
        class="guest-avatar"
        [title]="guest.firstName"
        [subtitle]="guest.lastName"
        [detail]="age"
        [avatar]="guest.avatar"
        [guest]="guest">
    </finder-avatar>
</div>
